import React from "react";
import MarketingPage from "./MarketingPage";

const tpls = [
  { name: "Safe Work Instruction", cat: "Safety", sections: ["Purpose","Scope","Required PPE","Isolation","Procedure","Records"] },
  { name: "Standard Operating Procedure", cat: "Operations", sections: ["Purpose","Scope","Definitions","Procedure","Records"] },
  { name: "Maintenance Procedure", cat: "Maintenance", sections: ["Purpose","Required PPE","Tools","Procedure","Frequency","Records"] },
  { name: "Inspection Form", cat: "Quality", sections: ["Purpose","Criteria","Frequency","Records"] },
  { name: "Policy", cat: "Governance", sections: ["Purpose","Scope","Policy Statement","Responsibilities","References"] },
  { name: "Technical Report", cat: "Engineering", sections: ["Executive Summary","Introduction","Methodology","Findings","Recommendations"] },
];

export default function Templates() {
  return (
    <MarketingPage eyebrow="Templates" title="Use your templates. Not ours." subtitle="Bring your own Microsoft Word templates. Fexidoc learns their structure and applies it across every document your team creates.">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tpls.map((t) => (
          <div key={t.name} className="fx-panel p-5 fx-hover-panel">
            <div className="mono text-[10px] uppercase tracking-widest text-slate-500">{t.cat}</div>
            <div className="font-display font-semibold text-slate-100 mt-1">{t.name}</div>
            <div className="mt-4 space-y-1">
              {t.sections.map((s, i) => (
                <div key={s} className="text-xs text-slate-400 flex items-center gap-2"><span className="mono text-slate-600 w-4">{String(i+1).padStart(2,"0")}</span>{s}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </MarketingPage>
  );
}
